import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
   export const GetAllClassStrSubsSecMapping = async (credentials) =>{
    return commonFetch(API_URLS.GETALL_CLASS_STREAM_SSTREAM_SEC_MAPPING_APIURL, {
      method: "POST",
      body: credentials,
      requiresAuth: true,
    })
  }

  export const GetAllClassWithDetailsMapping = async (schoolID) =>{
    return commonFetch(`${API_URLS.GETALL_CLASS_MAPPING_APIURL}/${schoolID}`, {
      method: "GET",
      requiresAuth: true,
    });
  }

  export const GetAllClassSectionMapping = async (schoolID) =>{
    return commonFetch(`${API_URLS.GET_CLASS_SECTION_CHECKBOX_APIURL}/${schoolID}`, {
      method: "GET",
      requiresAuth: true,
    });
  }
  
